/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_HelpInputs */

const en_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default text background used in the Closed Caption Preview.`)
};

const fr_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fond de texte par défaut utilisé dans l’aperçu des sous-titres.`)
};

const de_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardmäßiger Texthintergrund in der Untertitelvorschau.`)
};

const it_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfondo del testo predefinito usato nell’anteprima dei sottotitoli.`)
};

const ru_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фон текста по умолчанию, используемый в предварительном просмотре субтитров.`)
};

const es_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo de texto predeterminado usado en la vista previa de subtítulos.`)
};

const zh_cn2_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏式字幕预览中使用的默认文字背景。`)
};

const ja_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕プレビューで使用されるデフォルトのテキスト背景です。`)
};

const hi_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज़्ड कैप्शन प्रीव्यू में उपयोग होने वाली डिफ़ॉल्ट टेक्स्ट पृष्ठभूमि।`)
};

const pt_pt2_options_display_default_background_color_help = /** @type {(inputs: Options_Display_Default_Background_Color_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo de texto predefinido utilizado na pré-visualização de legendas.`)
};

/**
* | output |
* | --- |
* | "Default text background used in the Closed Caption Preview." |
*
* @param {Options_Display_Default_Background_Color_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_help = /** @type {((inputs?: Options_Display_Default_Background_Color_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_default_background_color_help(inputs)
	if (locale === "de") return de_options_display_default_background_color_help(inputs)
	if (locale === "it") return it_options_display_default_background_color_help(inputs)
	if (locale === "ru") return ru_options_display_default_background_color_help(inputs)
	if (locale === "es") return es_options_display_default_background_color_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_default_background_color_help(inputs)
	if (locale === "ja") return ja_options_display_default_background_color_help(inputs)
	if (locale === "hi") return hi_options_display_default_background_color_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_default_background_color_help(inputs)
	return en_options_display_default_background_color_help(inputs)
});